import account from './account';
import cart from './cart';
import checkout from './checkout';
import confirmation from './confirmation';
import globalEvents from './global';
import landing from './landing';
import orders from './orders';
import product from './product';
import search from './search';
import rewards from './rewards';
import favorites from './favorites';
import influencercollection from './influencercollection';
import influencerhub from './influencerhub';

// Mapping needs to match up with getType() output
export default {
  account,
  cart,
  checkout,
  confirmation,
  globalEvents,
  landing,
  orders,
  product,
  rewards,
  search,
  favorites,
  influencercollection,
  influencerhub
};
